import * as React from 'react';
export const pncSvg = React.forwardRef(function pncSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F48021',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M20.9 17.36h-2.24c.1-.23.05-.56-.14-.93l-1.25-2.1-2.1-3.67s-.79-1.49-1.95-2.37c.74.28 10.14 5.77 10.14 5.77 1.54.93 2.88 3.25-2.47 3.3zm-7.08 5.9c-1.53.89-4.28.89-1.63-3.76.47-.8 1.12-1.96 1.12-1.96.19.24.47.38.89.38h6.69s1.68.04 3.03-.51c-.6.46-10.1 5.86-10.1 5.86zm-3.2-12.83c0-1.77 1.39-4.14 4.09.46.46.84 1.11 1.96 1.11 1.96-.28.04-.5.23-.74.6l-1.21 2.14-2.14 3.63s-.88 1.44-1.07 2.93c-.1-.84-.05-11.72-.05-11.72zm5.34-4.38a9.93 9.93 0 1 0 9.96 9.9c0-5.48-4.47-9.9-9.96-9.9z',
      }),
    ),
  );
});
pncSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var pnc = {
  category: 'brand',
  colorable: false,
  name: 'pnc',
  svg: pncSvg,
};
